import React, { Component } from "react";
import { Accessor, GState, IconX, ZTime } from "IZOX/STATIC";
import PropsType from "prop-types";
import { observer } from "mobx-react";
import { HStack, XButton, XText } from "IZOX/_X";

/**
 * @augments {Component<Props, State>}
 */
class YearMonthSelector extends Component {

  static propTypes = {
    disYear: PropsType.number,
    disMonth: PropsType.number,
    _isValidYear: PropsType.func,
    _isValidMonth: PropsType.func,
    _onSelectorChange: PropsType.func,
    _onYearTextPress: PropsType.func,
    _onMonthTextPress: PropsType.func,
    styles: PropsType.object
  };

  static defaultProps = {
    disYear: ZTime.Now().year(),
    disMonth: ZTime.Now().month(),
    _isValidYear: null,
    _isValidMonth: null,
    _onSelectorChange: null,
    _onYearTextPress: null,
    _onMonthTextPress: null,
    styles: {}
  };

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(YearMonthSelector.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  };

  onLeftPress = () => {
    let {disMonth, disYear, _onSelectorChange} = this.props;
    if(disMonth === 0) { 
      disMonth = 11;
      disYear -= 1;
    }else{
      disMonth -= 1;
    }
    _onSelectorChange?.(disYear, disMonth);
    
  };

  onRightPress = () => {
    let {disMonth, disYear, _onSelectorChange} = this.props;
    if(disMonth === 11) { 
      disMonth = 0;
      disYear += 1;
    }else{
      disMonth += 1;
    }
    _onSelectorChange?.(disYear, disMonth);
  };

  onDLeftPress = () => {
    let {disMonth, disYear, _onSelectorChange} = this.props;
    disYear -= 1;
    _onSelectorChange?.(disYear, disMonth);
  };

  onDRightPress = () => {
    let {disMonth, disYear, _onSelectorChange} = this.props;
    disYear += 1;
    _onSelectorChange?.(disYear, disMonth);
  };

  onYearTextPress = () => {
    let {_onYearTextPress} = this.props;

    _onYearTextPress?.();
  };

  onMonthTextPress = () => {
    let {_onMonthTextPress} = this.props;
    _onMonthTextPress?.();
  };

  renderBtn(icon, func, disabled = false){
    let {size, styles} = this.props;
    return (
      <XButton onClick={func} 
        style={styles.shiftBtn(size)} 
        disabled={disabled}>
        {icon}
      </XButton>
    );
  }

  renderMonth(){
    let {size, styles} = this.props;
    let {disMonth} = this.state;
    let str = ZTime.monthDis?.[GState.lang]?.Full?.[disMonth];

    return (
      <XButton style={styles.disMonthTextView(size)}
        onClick={this.onMonthTextPress}>
        <XText style={styles.disText(size)}>
          {str}
        </XText>
      </XButton>
    );
  }

  renderYear(){
    let {size, styles} = this.props;
    let {disYear} = this.state;
    let str = String(disYear);
    return (
      <XButton style={styles.disYearTextView(size)}
        onClick={this.onYearTextPress}>
        <XText style={styles.disText(size)}>
          {str}
        </XText>
      </XButton>
    );
  }

  render(){
    let {disYear, disMonth, _isValidMonth, _isValidYear, size, styles} = this.props;
    let hasLastYear = _isValidYear(disYear - 1);
    let hasLastMonth = disMonth === 0?
      _isValidMonth(disYear - 1, 11) :
      _isValidMonth(disYear, disMonth - 1);
    let hasNextYear = _isValidYear(disYear + 1);
    let hasNextMonth = disMonth === 11?
      _isValidMonth(disYear + 1, 0) :
      _isValidMonth(disYear, disMonth + 1);

    let iconSize = size > 30 ? "medium" : "20px";

    return (
      <HStack fullWidth style={styles.topBar}>
        {this.renderBtn(
          IconX.Get("mui", "keyboarddoubleleft", iconSize,
            hasLastYear? styles.shiftIcon.color 
            : styles.shiftIconDisabled.color),
          this.onDLeftPress,
          !hasLastYear)}
        {this.renderBtn(
          IconX.Get("mui", "chevron-left", iconSize, 
            hasLastMonth? styles.shiftIcon.color 
            : styles.shiftIconDisabled.color),
          this.onLeftPress,
          !hasLastMonth)}
        {this.renderMonth()}
        {this.renderYear()}
        {this.renderBtn(
          IconX.Get("mui", "chevron-right", iconSize,
            hasNextMonth? styles.shiftIcon.color 
            : styles.shiftIconDisabled.color),
          this.onRightPress,
          !hasNextMonth)}
        {this.renderBtn(
          IconX.Get("mui", "keyboarddoubleright", iconSize,
            hasNextYear? styles.shiftIcon.color 
            : styles.shiftIconDisabled.color),
          this.onDRightPress,
          !hasNextYear)}
      </HStack>
    );
  }

}

export default observer(YearMonthSelector);
